import "parsleyjs/dist/parsley.min"
import "./parsleyjs/i18n/de"
import "./parsleyjs/i18n/de.extra"

export default function parsleyValidation() {
  $('.needs-validation').parsley();
}
